import React, { useEffect, useState } from "react";
import DashSplitContainer from "../DashSplitContainer";
import TruckSearchPanel from "./TruckSearchPanel";
import TruckDetail from "./TruckDetail";
import COLORS from "../../../../constants/Colors";
import { useDashLayoutCtx } from "../DashLayoutCtxProvider";
import SavedTrucks from "./SavedTrucks";
// import { useDashLayoutCtx } from "../DashLayoutCtxProvider";

function DashTrucks() {
  const [searchRegNo, setsearchRegNo] = useState(null);
  const { useLSecView, setuseLSecView, setsplitView, settransferBin } = useDashLayoutCtx();
  useEffect(() => {
    setuseLSecView(false);
    setsearchRegNo(null);
    settransferBin(null);
    // eslint-disable-next-line
  }, []);
  return (
    <DashSplitContainer
      heading="Trucks"
      showAction={true}
      actionLabel={useLSecView ? "Search New" : "View Saved"}
      actionFunc={() => {
        setuseLSecView((val) => !val);
        setsearchRegNo(null);
        setsplitView(false);
        settransferBin(null);
      }}
      headingBgColor={COLORS.GREEN_TRUCK_GRAD}
    >
      {useLSecView ? (
        <SavedTrucks setRegNo={setsearchRegNo} />
      ) : (
        <TruckSearchPanel vehRegNo={searchRegNo} setRegNo={setsearchRegNo} />
      )}
      <TruckDetail vehRegNo={searchRegNo} setRegNo={setsearchRegNo} />
    </DashSplitContainer>
  );
}

export default DashTrucks;
